/* eslint-disable @typescript-eslint/no-explicit-any */

import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import { trackEvent } from '@mercadoni/sinister/dist/cjs/monitors/services'
import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import getDeliveryText from './useCases/getDeliveryText'
import getStoreText from './useCases/getStoreText'

const OpModelLogic = ({ Wrapper }: { Wrapper: any }) => {
  const {
    onClickOpModel,
    copies,
    opsmodel = {},
    address = {},
    store = {},
    showAddressLabel,
    clientId,
    enabledOpModelSuffix,
  } = useHeaderContext()

  const { clients: copy } = copies
  const { delivery, collect, location } = copy?.generalheader || {}
  const { noaddress } = location || {}
  const opModelOptions = useMemo(
    () => ({
      DELIVERY: {
        icon: 'ph-truck',
        title: delivery,
        text: getDeliveryText({
          copies,
          enabledOpModelSuffix: enabledOpModelSuffix || false,
          address,
          showAddressLabel: showAddressLabel || false,
        }),
      },
      PICK_AND_COLLECT: {
        icon: 'ph-shopping-bag-open',
        title: collect,
        text: getStoreText({
          copies,
          storeName: store.name,
          enabledOpModelSuffix: enabledOpModelSuffix || false,
        }),
      },
      PICK_UP: {
        icon: 'ph-shopping-bag-open',
        title: collect,
        text: getStoreText({
          copies,
          storeName: store.name,
          enabledOpModelSuffix: enabledOpModelSuffix || false,
        }),
      },
      DEFAULT: {
        icon: 'ph-map-pin',
        title: noaddress,
        text: '',
      },
    }),
    [
      delivery,
      copies,
      enabledOpModelSuffix,
      address,
      showAddressLabel,
      collect,
      store.name,
      noaddress,
    ]
  )
  const [selectedOpModel, setSelectedOpModel] = useState(opModelOptions.DEFAULT)

  const onClick = () => {
    trackEvent({
      eventName: 'home_op_model_clicked',
      clientId,
    })
    onClickOpModel?.()
  }

  useEffect(() => {
    const _model = opsmodel?.opsModel
    const selectedModel = opModelOptions[_model as keyof typeof opModelOptions]
    if (_model && selectedModel) {
      setSelectedOpModel(selectedModel)
      return
    }
    setSelectedOpModel(opModelOptions.DEFAULT)
  }, [opsmodel, opModelOptions])

  return <Wrapper {...selectedOpModel} onClick={onClick} />
}

export default OpModelLogic

OpModelLogic.propTypes = {
  Wrapper: PropTypes.func.isRequired,
}
